import { FETCH_APP_DATA_ASYNC } from 'containers/App/constants'
import {
  selectActualCompanyId,
  selectEnvironment,
  selectRegion,
  selectSelfCompanyId,
  selectSelfIsPartner,
  selectUserId,
} from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { setFeatureFlagsIdentity } from './index'

const IDENTITY_ACTIONS = [FETCH_APP_DATA_ASYNC.SUCCESS, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS]

/**
 * Keeps flag targeting in sync with who is looking: once on app data load, then
 * again whenever an MSP switches the selected company (mirrors
 * `pendoMSPSupportMiddleware`).
 */
export const featureFlagsIdentityMiddleware = (store) => (next) => (action) => {
  const result = next(action) // reach the reducer first

  if (IDENTITY_ACTIONS.includes(action.type)) {
    const state = store.getState()

    setFeatureFlagsIdentity({
      userId: selectUserId(state),
      companyId: selectActualCompanyId(state),
      selfCompanyId: selectSelfCompanyId(state),
      isPartner: selectSelfIsPartner(state),
      environment: selectEnvironment(state),
      region: selectRegion(state),
    })
  }

  return result
}
